import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = require("@/router/routes").default;

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  // navigate to the top of the page
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes
});

//TODO add middleware to check if this order is already finished or not
export default router;
